import Loader from "components/Shared/Loader/Loader"
import { useAppSelector } from "hooks/hooksStore"
import { NavMenuItem } from "interfaces/dataInterfaces"
import { useEffect, useState } from "react"
import { useGetNavMenuQuery } from "services/core/navigationMenu"
import SidebarMenuItem from "./SidebarMenuItem"

interface SidebarWrapperProps {
  item: NavMenuItem
}

function SidebarWrapper({ item }: SidebarWrapperProps) {
  const [depth, setDepth] = useState<number>(0)
  return <SidebarMenuItem item={item} depth={depth} setDepth={setDepth} />
}

function SidebarMenu() {
  const { data: navMenuList, isLoading, isError } = useGetNavMenuQuery()

  // State
  const [list, setList] = useState<NavMenuItem[] | undefined>([])

  // Redux State
  const isOpenSidebar = useAppSelector(state => state.sidebar.open)

  // TODO: Create them auto from the api data
  // Side Effects
  useEffect(() => {
    const staticAimsItem: NavMenuItem = {
      text: "AIMS",
      link: "/aims/AssetsView",
      icon: "fa-globe",
      children: [
        {
          text: "Assets",
          link: "/aims/AssetsView",
          icon: "fa-folder",
          children: [],
        },
        {
          text: "ADA",
          link: "/aims/ADA",
          icon: "fa-table",
          children: [],
        },
        {
          text: "LIA",
          link: "/aims/LIA",
          icon: "fa-file",
          children: [],
        },
        {
          text: "Contracts",
          link: "/aims/Contracts",
          icon: "fa-exclamation-triangle",
          children: [],
        },
        {
          text: "Settings",
          link: "/aims/Settings",
          icon: "",
          children: [],
        },
      ],
    }

    // If the nav API fails or returns nothing, fall back to the static AIMS menu only.
    if (isError || !navMenuList || !navMenuList.length) {
      setList([staticAimsItem])
      return
    }

    // Otherwise, keep backend items and append the static AIMS block.
    setList([...navMenuList, staticAimsItem])
  }, [isError, navMenuList])

  return (
    <nav className={`sidebar-menu${isOpenSidebar ? " menu-open" : " menu-close"}`}>
      <ul className="sidebar-menu--list h-100">
        {list?.length ? (
          list?.map((item: NavMenuItem, index: number) => (
            <li className="sidebar-menu--item" key={`menu-list-${index}`}>
              <SidebarWrapper item={item} />
            </li>
          ))
        ) : isLoading ? (
          <Loader size="small" color="secondary" />
        ) : (
          <div className="d-flex align-center h-100 text-white justify-center">No data are available</div>
        )}
      </ul>
    </nav>
  )
}

export default SidebarMenu
